import styled, { keyframes } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

const slideIn = keyframes`
0% { opacity: 0; transform: translateY(-10px); }
100% { opacity: 1; transform: translateY(0); }
`;

export const TreeNodeContainer = styled.div`
	padding: 0 10px;
	overflow: hidden;
`;

export const TreeNodeTitle = styled.div`
	display: flex;
	align-items: center;
`;

export const VisibilityWrapper = styled.div`
	visibility: ${props => (props.isVisible ? '' : 'hidden')};
	.expandLess,
	.expandMore {
		height: 25px;
		width: 25px;
	}
`;

export const ActionWrapper = styled.div`
	display: flex;
	align-items: center;
	.delete {
		height: 25px;
		width: 25px;
		svg {
			width: 20px;
			height: 20px;
		}
	}
	.category-title {
		font-size: 14px;
		padding: 2px 8px;
		height: 30px;
		color: ${props =>
			props.isSelectedCategory ? colors.green500 : colors.grey5};
	}
`;

export const TreeNodeChildren = styled.div`
	animation-name: ${slideIn};
	animation-duration: 0.3s;
	animation-timing-function: linear;
`;
